import React from 'react'
import { Redirect } from 'react-router-dom'

interface IRedirect404 {
  path?: string
}

const Redirect404: React.FC<IRedirect404> = ({ path }) => {
  return <Redirect to={path ? path : '/404'} />
}

export default Redirect404
